import { MiningRewards } from '../types/mining.types';

export const useMiningRewards = () => {
    const calculateRewards = (
      dateStart: string,
      dateEnd: string,
      originalDateEnd: string,
      totalAmount: number,
      totalAmountUsdt: number,
      status: string
    ): MiningRewards => {
      if (status !== 'process') {
        return {
          currentDC: Number(totalAmount.toFixed(3)),
          currentUSDT: Number(totalAmountUsdt.toFixed(4)),
          totalDC: totalAmount,
          totalUSDT: totalAmountUsdt,
          percentageComplete: 100
        };
      }
  
      const start = new Date(dateStart + 'Z').getTime();
      const end = new Date(dateEnd + 'Z').getTime();
      const originalEnd = new Date(originalDateEnd + 'Z').getTime();
      const now = Date.now();

      if (now <= start) {
        return {
          currentDC: 0,
          currentUSDT: 0,
          totalDC: totalAmount,
          totalUSDT: totalAmountUsdt,
          percentageComplete: 0
        };
      }

      // Если время уже вышло
      if (now >= end) {
        return {
          currentDC: Number(totalAmount.toFixed(3)),
          currentUSDT: Number(totalAmountUsdt.toFixed(4)),
          totalDC: totalAmount,
          totalUSDT: totalAmountUsdt,
          percentageComplete: 100
        };
      }

      // Базовый прогресс относительно текущей длительности
      const elapsed = now - start;
      const currentDuration = end - start;
      
      // Оставшееся время
      const remainingTime = end - now;
      
      // Если осталось меньше 30 минут, используем специальную формулу
      if (remainingTime <= 30 * 60 * 1000) { // 30 минут в миллисекундах
        // Рассчитываем процент на основе оставшегося времени
        // от 0 до 30 минут = от 95% до 99.9%
        const remainingMinutes = remainingTime / (60 * 1000);
        let percentageComplete = 99.9 - (remainingMinutes / 30) * 5;
        return {
          currentDC: Number((totalAmount * (percentageComplete / 100)).toFixed(3)),
          currentUSDT: Number((totalAmountUsdt * (percentageComplete / 100)).toFixed(4)),
          totalDC: totalAmount,
          totalUSDT: totalAmountUsdt,
          percentageComplete: Number(percentageComplete.toFixed(2))
        };
      }

      // Стандартный расчет для времени > 30 минут
      let percentageComplete = (elapsed / currentDuration) * 100;

      if (end < originalEnd) {
        const timeDifference = originalEnd - end;
        const reductionPercent = (timeDifference / (originalEnd - start)) * 100;
        // Ограничиваем максимальный процент от ускорения
        const maxBoostPercent = 95 - percentageComplete;
        const actualBoostPercent = Math.min(reductionPercent * 0.9, maxBoostPercent);
        percentageComplete += actualBoostPercent;
      }

      percentageComplete = Math.min(95, Math.max(0, percentageComplete));
  
      return {
        currentDC: Number((totalAmount * (percentageComplete / 100)).toFixed(3)),
        currentUSDT: Number((totalAmountUsdt * (percentageComplete / 100)).toFixed(4)),
        totalDC: totalAmount,
        totalUSDT: totalAmountUsdt,
        percentageComplete: Number(percentageComplete.toFixed(2))
      };
    };
  
    return { calculateRewards };
};